import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "feedback",
  initialState: {
    feedback: {
      data: [],
      pagination: {
        current_page: 1,
        filtered_record: 0,
        record_per_page: 0,
        total_page: 0,
        total_record: 0,
        total_record_on_current_page: 0,
      },
    },
    profileFeedback: [],
    loading: false,
    lastFetch: null,
  },
  reducers: {
    feedbackRequested: (feedback) => {
      feedback.loading = true;
    },
    feedbackRecieved: (feedback, action) => {
      console.log("feedback--0000000000---> ")
      console.log("feedback--88---> ", action.payload)
      feedback.feedback = action.payload;
      feedback.loading = false;
      feedback.lastFetch = Date.now();
    },
    feedbackRequestFailed: (feedback) => {
      feedback.feedback = {};
      feedback.loading = false;
    },
    profileFeedbackRequested: (feedback) => {
      feedback.loading = true;
    },
    profileFeedbackRecieved: (feedback, action) => {
      feedback.profileFeedback = action.payload;
      feedback.loading = false;
      feedback.lastFetch = Date.now();
    },
    profileFeedbackRequestFailed: (feedback) => {
      feedback.profileFeedback = [];
      feedback.loading = false;
    },
    togglePublishSuccess: (state, action) => {
      const feedback =
        state.feedback.data.find(
          item =>
            item._id === action.payload.id
        )

      if (feedback) {
        feedback.featured_on_profile =
          action.payload.featured_on_profile
      }
    },
  },
});

export const {
  feedbackRequested,
  feedbackRecieved,
  feedbackRequestFailed,
  profileFeedbackRequested,
  profileFeedbackRecieved,
  profileFeedbackRequestFailed,
  togglePublishSuccess,
} = slice.actions;
export default slice.reducer;

const url = "feedback/";

export const loadfeedback = (params, callback = null) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: url,
      params,
      onStart: feedbackRequested.type,
      onSuccess: feedbackRecieved.type,
      onError: feedbackRequestFailed.type,
      callback,
    })
  );
};

export const loadProfileFeedback = (id) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: url + 'featured/' + id,
      onStart: profileFeedbackRequested.type,
      onSuccess: profileFeedbackRecieved.type,
      onError: profileFeedbackRequestFailed.type,
    })
  );
};

export const togglePublish =
  (id, callback = null) => dispatch => {
    return dispatch(
      apiCallBegan({
        url: url + "publish/" + id,
        method: "put",
        onSuccess: togglePublishSuccess.type,
        callback,
      })
    )
  }

export const getFeedback = createSelector(
  (state) => state.entities.feedback,
  (feedback) => feedback
);
